export default function () {
    return {
        'Content-Type': 'application/x-www-form-urlencoded',
        // 'Content-Type': 'application/json',
        // 'Access-Control-Allow-Origin': '*',
    };
}
